import { Route } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { LayoutComponent } from './layout/layout.component';
import { AdminRoutes } from './routes/admin.routes';

import { CustomerRoutes } from './routes/customer.routes';
import { EventDetailRoute, EventListRoute } from './routes/event.routes';
import { FloorPlanRoutes } from './routes/floor-plan.routes';
import { NotificationBatchRoutes } from './routes/notification-batch.routes';
import { PostRoutes } from './routes/post.routes';
import { ShopRoutes } from './routes/shop.routes';
import { SiteRoutes } from './routes/site.routes';
import { StatisticsRoutes } from './routes/stat.routes';
import { UserRoutes } from './routes/user.routes';
import { QrCodeRoutes } from './routes/qr-code.routes';

export const appRoutes: Route[] = [
  {
    path: 'sign-in',
    loadComponent: () => import('./pages/auth/sign-in/sign-in.page'),
  },
  {
    path: 'sign-up',
    loadComponent: () => import('./pages/auth/sign-up/sign-up.page'),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.page'),
      },
      ...UserRoutes,
      ...AdminRoutes,
      ...CustomerRoutes,
      ...SiteRoutes,
      ...FloorPlanRoutes,
      ...PostRoutes,
      ...NotificationBatchRoutes,
      EventListRoute,
      {
        path: 'my-page',
        loadComponent: () => import('./pages/my-page/my-page.page'),
      },
      ...StatisticsRoutes,
      ...QrCodeRoutes,

    ],
  },
  EventDetailRoute,
  ...ShopRoutes,
];
